import { ADD_USERS, ADD_USERS_FAILED, ADD_USERS_SUCCESS, UPDATE_USERS, UPDATE_USERS_FAILED, UPDATE_USERS_SUCCESS, USERS, USERS_FAILED, USERS_SUCCESS, USERSLIST } from "./actionTypes"

let initialState = {
    users: [],
    addUsers: "",
    updateUser: "",
    loading: false,
    usersLoading: false,
    success: false,
    error: ''
}

export const userReducer = (state = initialState, action) => {
    switch (action.type) {

        case USERS: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case USERSLIST: return {
            ...state,
            usersLoading: true,
            success: false,
            error: ''
        }
        case USERS_SUCCESS: return {
            ...state,
            users: action.payload,
            loading: false,
            usersLoading: false,
            success: true
        }
        case USERS_FAILED: return {
            ...state,
            loading: false,
            usersLoading: false,
            success: false,
            error: action.payload
        }
        case ADD_USERS: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_USERS_SUCCESS: return {
            ...state,
            addUsers: action.payload,
            users: [...state.users, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_USERS_FAILED: return {
            ...state,
            addUsers: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATE_USERS: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATE_USERS_SUCCESS: return {
            ...state,
            updateUser: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_USERS_FAILED: return {
            ...state,
            updateUser: [],
            loading: false,
            success: false,
            error: action.payload
        }

        default: return state
    }
}